import { jsx as _jsx } from "react/jsx-runtime";
import MainPage from "@/pages/main_page/MainPage";
import { Suspense } from "react";
import { createBrowserRouter, RouterProvider, Navigate, useLocation } from "react-router-dom";
import { RoutesList, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "./routesList";
import Article from "@/components/article/Article";
import MultiContentView from "@/components/multi_content_view/MultiContentView";
var RedirectToLanguage = function () {
    var location = useLocation();
    var lang = location.pathname.split('/').filter(Boolean)[0];
    if (SUPPORTED_LANGUAGES.includes(lang)) {
        return _jsx(Navigate, { to: "/".concat(lang), replace: true });
    }
    return _jsx(Navigate, { to: "/".concat(DEFAULT_LANGUAGE).concat(location.pathname), replace: true });
};
var router = createBrowserRouter([
    {
        path: "/",
        element: _jsx(Navigate, { to: "/".concat(DEFAULT_LANGUAGE), replace: true })
    },
    {
        path: "/:lang",
        element: _jsx(Suspense, { fallback: "Loading...", children: _jsx(MainPage, {}) }),
        children: [
            {
                index: true,
                element: _jsx(Article, { pageName: "welcome" })
            },
            {
                path: RoutesList.WhySahlTaxVsAgencies,
                element: _jsx(Article, { pageName: "whySahlTaxVsAgencies" })
            },
            {
                path: RoutesList.PricingPlans,
                element: _jsx(Article, { pageName: "pricingPlans" })
            },
            {
                path: RoutesList.Integrations,
                element: _jsx(Article, { pageName: "integrations" })
            },
            {
                path: RoutesList.TermsOfService,
                element: _jsx(Article, { pageName: "termsOfService" })
            },
            {
                path: RoutesList.FAQ,
                element: _jsx(MultiContentView, { title: "FAQ" })
            },
            {
                path: RoutesList.FAQBankStatementProcessing,
                element: _jsx(Article, { pageName: "faqBankStatementProcessing" })
            },
            {
                path: RoutesList.FAQTaxableIncome,
                element: _jsx(Article, { pageName: "faqTaxableIncome" })
            },
            {
                path: RoutesList.FAQReliefGuide,
                element: _jsx(Article, { pageName: "faqReliefGuide" })
            },
            {
                path: RoutesList.FAQTaxImplications,
                element: _jsx(Article, { pageName: "faqTaxImplications" })
            },
            {
                path: RoutesList.FAQBestSoftware,
                element: _jsx(Article, { pageName: "faqBestSoftware" })
            },
            {
                path: RoutesList.FAQReferal,
                element: _jsx(Article, { pageName: "faqReferal" })
            },
            {
                path: RoutesList.CookiesPolicy,
                element: _jsx(Article, { pageName: "cookiesPolicy" })
            },
            {
                path: RoutesList.PrivacyAndSecurity,
                element: _jsx(Article, { pageName: "privacyAndSecurity" })
            },
            {
                path: RoutesList.CancellationPolicy,
                element: _jsx(Article, { pageName: "cancellationPolicy" })
            },
            {
                path: RoutesList.WhySahlTax,
                element: _jsx(Article, { pageName: "whySahlTax" })
            },
        ]
    },
    {
        path: "*",
        element: _jsx(RedirectToLanguage, {})
    }
]);
var AppRouter = function () {
    return _jsx(RouterProvider, { router: router });
};
export default AppRouter;
